import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";

export interface Fetch {
    invoiceId: string;
    callback: (success: boolean, code?: string) => void;
}

export interface RequestInvoiceAction {
    type: string;
    payload: Fetch;
}

export default function* requestInvoice({
    payload,
}: RequestInvoiceAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const { apiInstance } = getApiConfig(true);
        const response = yield call(apiInstance.get, `/internalwebapi/v1/vehicle-debts/internal-payment-receipt/${payload.invoiceId}`);

        const payloadData = Array.isArray(response?.data) ? response?.data : response?.data?.data;

        if (payloadData) {
            yield call(payload.callback, true, payloadData);
        } else {
            yield call(payload.callback, false, "timeout");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}